import { toast } from 'react-toastify';

export function createThunkAction(apiCall, setDataAction, setLoadingAction) {
  return (params) => async (dispatch) => {
    try {
      dispatch(setLoadingAction(true));
      const response = await apiCall(params);

      if (response.status === 200) {
        dispatch(setDataAction(response.data?.data ?? response.data));
      } else {
        throw response;
      }
    } catch (err) {
      toast.error('Internal server error');
      console.error(err);
    } finally {
      dispatch(setLoadingAction(false));
    }
  };
}
